import React from "react";

const ErrorScreen = () => {
  return <h1>&nbsp;&nbsp;&nbsp;&nbsp;Error Page</h1>;
};

export default ErrorScreen;
